<!--问卷移动端-->
<template>
  <div class="content">
    <div class="box" v-if="!isSuccess">
      <div class="top-bj"
           :style="{height: settingData.skin.data.head.height/16+'rem',background: settingData.skin.type ===1?'url('+settingData.skin.data.head.image+')center':settingData.skin.data.background.color,backgroundSize: settingData.skin.data.head.repeat==='x'?'contain':'cover'}">
      </div>
      <div class="title">
        <h1 v-html="formData.title"></h1>
        <p v-html="formData.desc"></p>
      </div>

      <div :class="['main',{paddingB:isPage}]">
        <div class="form-conten" v-for="item in formDataArr" :key="item.id">
          <t-casader :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 6"></t-casader>
          <t-input :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 1"></t-input>
          <t-check :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 4"></t-check>
          <t-radio :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 3"></t-radio>
          <t-text-area :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 2"></t-text-area>
          <t-select :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 5"></t-select>
          <t-time-picker :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 13"></t-time-picker>
          <t-date-picker :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 12"></t-date-picker>
          <t-mail-address :question="item" :number="filterIndexFn(item.number)"
                          v-if="item.type === 14"></t-mail-address>
          <t-tel-code :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 15"></t-tel-code>
          <t-uplod :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 7"></t-uplod>
          <t-score-xin :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 11"></t-score-xin>
          <t-score-radio :question="item" :number="filterIndexFn(item.number)" v-if="item.type === 10"></t-score-radio>
          <t-fenge-fu :question="item" v-if="item.type === 8"></t-fenge-fu>
        </div>
      </div>

      <div :class="['footer',{footerPage:isPage}]">
        <Button type="primary" :disabled="page===0" ghost @click="lastPageClick" v-if="isPage">上一页</Button>
        <Button type="primary" ghost @click="nextPageClick" v-if="isPage && !isSubmitBtn">下一页</Button>
        <Button type="primary" v-if="isSubmitBtn" @click="checkSubmit">提交</Button>
      </div>
    </div>
    <div class="success" v-else>
      <div><img src="../../assets/images/success.png" alt=""></div>
      <h1>提交成功</h1>
      <p>表单信息已提交长江云后台，感谢参与</p>
    </div>

  </div>
</template>

<script>
import {formDetail, formSetting, formSubmit} from "../../api/Interface";
import TCasader from "../../components/topicType/tCasader";
import TInput from "../../components/topicType/tInput";
import TCheck from "../../components/topicType/tCheck";
import TRadio from "../../components/topicType/tRadio";
import TTextArea from "../../components/topicType/tTextArea";
import TSelect from "../../components/topicType/tSelect";
import TTimePicker from "../../components/topicType/tTimePicker";
import TDatePicker from "../../components/topicType/tDatePicker";
import TMailAddress from "../../components/topicType/tMailAddress";
import TTelCode from "../../components/topicType/tTelCode";
import TUplod from "../../components/topicType/tUplod";
import TScoreXin from "../../components/topicType/tScoreXin";
import TScoreRadio from "../../components/topicType/tScoreRadio";
import TFengeFu from "../../components/topicType/tFengeFu";
import {mapState} from 'vuex'

export default {
  name: "activity",
  components: {
    TFengeFu,
    TScoreRadio,
    TScoreXin,
    TUplod,
    TTelCode,
    TMailAddress,
    TDatePicker,
    TTimePicker,
    TSelect,
    TTextArea,
    TRadio,
    TCheck,
    TInput,
    TCasader
  },
  data() {
    return {
      formData: {},
      isPage: true, //有无分页
      isSubmitBtn: false,
      formDataArr: [],
      pageNewData: [],
      page: 0,
      isSuccess: false
    }
  },
  computed: {
    ...mapState(['settingData'])
  },
  mounted() {
    this.getFormDetailData()
  },
  methods: {
    //获取表单详情
    getFormDetailData() {
      let data = {
        form_id: this.$store.state.formId
      }
      formDetail(data).then(res => {
        if (res.state) {
          for (let k = 0; k < res.data.question.length; k++) {
            res.data.question[k].number = k
          }
          this.formData = res.data
          let options = {}
          const idArr = this.formData.question.map(res => {
            return res.id
          })
          for (let i = 0; i < idArr.length; i++) {
            options[idArr[i]] = ''
          }
          //如果答案vuex中的答案对象(user_answers)为空就初始化答案对象，有答案则不初始化，防止答案丢失
          if (JSON.stringify(this.$store.state.user_answers) === '{}') {
            this.$store.commit('initUserAnswers', options)
          }
          //判断有无分页
          if (res.data.special_items && res.data.special_items.length > 0) {
            let pageArr = res.data.special_items.map(res => {
              return res.key
            })
            for (let j = 0; j <= pageArr.length; j++) {
              let arr = []
              if (j === 0) {
                arr = this.formData.question.slice(0, pageArr[0])
              } else if (j === 1 && j < pageArr.length) {
                arr = this.formData.question.slice(pageArr[0], pageArr[j] - j)
              } else if (j > 1 && j < pageArr.length) {
                arr = this.formData.question.slice(pageArr[j - 1] - (j - 1), pageArr[j] - j)
              } else if (j === pageArr.length) {
                arr = this.formData.question.slice(pageArr[pageArr.length - 1] - (j - 1))
              }
              this.pageNewData.push(arr)
            }
            this.isPage = true
            this.formDataArr = this.pageNewData[this.page]
          } else {
            this.formDataArr = res.data.question
            this.isPage = false
            this.isSubmitBtn = true
          }
        } else {
          this.$Message.error(res.error)
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //过滤掉分隔符，分隔页的题目序号
    filterIndexFn(index) {
      let beforeArr = this.formData.question.slice(0, index)
      let pageOrFu = beforeArr.filter(res => {
        return res.type === 8 || res.type === 9
      })
      let newIndex = index - pageOrFu.length
      return newIndex + 1
    },
    //上一页
    lastPageClick() {
      this.page = this.page - 1
      this.page === this.pageNewData.length - 1 ? this.isSubmitBtn = true : this.isSubmitBtn = false
      this.formDataArr = this.pageNewData[this.page]
      this.returnTop();
    },
    //下一页
    nextPageClick() {
      this.page = this.page + 1
      this.page === this.pageNewData.length - 1 ? this.isSubmitBtn = true : this.isSubmitBtn = false
      this.formDataArr = this.pageNewData[this.page]
      this.returnTop();
    },
    // 提交前请求校验
    checkSubmit(){
      formSetting(this.$route.query.id).then(res=>{
        if(res.state){
          this.submitFormDataClick();
        }else{
          this.$Message.error(res.error);
        }
      }).catch(error=>{
        console.log(error)
      })
    },
    //提交问卷
    submitFormDataClick() {
      // 临时添加选项限制
      if(this.$route.query.id == '736'&&this.$store.state.user_answers){
          let full_count = 0,values = Object.values(this.$store.state.user_answers)
        full_count = values.filter((item,i)=>{
          return item == 5 && item!=''
        }).length;
        if(full_count < 6){this.$Message.error("请选择6个非常满意后再提交");return false;}
      }
      this.$Modal.confirm({
        content: '是否确认提交？',
        render: (h, params) => {
          return h('div', [
            h('div', {
              style: "font-size: 20px; text-align: center;margin-bottom: 30px;"
            }, '是否确认提交？'),
          ]);
        },
        onOk: () => {
          let data = {
            form_id: this.$store.state.formId,
            user_answers: this.$store.state.user_answers
          }

          let requireArr = []
          this.formDataArr.forEach((item,i)=>{
            if(item.verify_rule.is_require){
              if(this.$store.state.user_answers[item.id]===''){
                requireArr.push(item.title)
              }
            }
          })
          if(requireArr.length>0){
            let errorStr = requireArr.join(',');
            this.$Message.error(errorStr+'为必填项!')
            return;
          }
          if(this.$store.state.settingData.base.login_code_limit){
            data.authcode = this.$store.state.loginCode;
          }
          formSubmit(data).then(res => {
            let that = this
            if (res.state) {
              setTimeout(function () {
                that.$Modal.success({
                  title: '提交成功',
                  onOk: function () {
                    that.isSuccess = true
                  }
                });
              }, 500)
              this.$store.commit('saveLoginCode', '')
              this.$store.commit('isSubmit', true)
            } else {
              setTimeout(function () {
                that.$Modal.error({
                  title: '提交失败',
                  content: res.error
                });
              }, 500)
            }
          }).catch(error => {
            console.log(error);
          })
        },
        onCancel: () => {

        }
      });
    },
    returnTop(){
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 10;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 5);
    }
  }
}
</script>

<style lang="scss">
.ivu-input:focus {
  outline: none;
  border-color: #dcdee2;
  box-shadow: none;
}

.ivu-input:hover {
  border-color: #dcdee2;
}

.ivu-modal {
  width: 65% !important;
  margin: 35% auto 0 auto;

  .ivu-modal-confirm-body {
    font-size: 14px;
    padding-left: 0;
  }

  .ivu-modal-confirm-footer {
    /*margin-top: 40px;*/
    text-align: center;

    .ivu-btn-text {
      border: 1px solid #d9d9d9;
    }

    .ivu-btn-primary {
      background-color: #3760f4;
      border-color: #3760f4;
    }
  }
}

.ivu-input-wrapper {
  width: 100% !important;
}

.question-item-title {
  font-size: 16px;
  color: #000;
  display: flex;
  align-items: flex-end;
  line-height: 30px;

  .q-title {
    p {
      display: contents;
    }
  }

  .ivu-icon {
    color: #FF6600;
    font-size: 20px;
    margin-left: 15px;
    padding-bottom: 3px;
  }
}

.hintModel {
  .ivu-modal-header {
    border-bottom: none;

    .ivu-icon {
      color: #FF6600;
      font-size: 20px;
      padding-bottom: 3px;
      margin-right: 12px;
    }

    span {
      font-size: 16px;
      font-weight: 600
    }
  }

  .ivu-modal-footer {
    p {
      color: #FF6600;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
    }
  }
}

.isMbottom {
  margin-bottom: 15px;
}

.title-tips {
  color: #c5c8ce;
  font-size: 14px;
  margin-bottom: 15px;
  display: inline-block;
  padding-left: 24px;
  &.length{
    padding:0;
    &.red{
      color:#F56C6C;
    }
  }
}

.q-content {
  .scoerBoxIndex0 {
    display: flex;
    flex-direction: column;

    > span {
      font-size: 14px;
    }

    .ivu-radio-group {
      margin: 5px 0;
    }
  }

  .scoerBoxIndex3 {
    display: flex;
    flex-direction: column;
  }
}
</style>

<style lang="scss" scoped>
.content {
  .box {
    position: relative;
    height: 100%;
  }

  .top-bj {
    width: 100%;
    height: 130px;
    /*background: url("../../assets/images/answer_bj.png") no-repeat center;*/
    background-size: cover;
    position: relative;
  }

  .title {
    padding: 0 15px;

    h1 {
      font-size: 18px;
      color: #303133;
      font-weight: 500;
      padding: 10px 0;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    p {
      color: #303133;
      font-size: 14px;
      word-break: break-all;
    }
  }

  .main.paddingB {
    padding: 22px 15px 50px 15px;
  }

  .main {
    padding: 22px 15px 100px 15px;

    .form-conten {
      & > div {
        margin-bottom: 20px;
      }
    }
  }

  .footer.footerPage {
    justify-content: space-between;
    position: fixed;
    bottom: 0;
  }

  .footer {
    width: 100%;
    height: 50px;
    padding: 0 15px;
    background: #ffffff;
    box-shadow: 0px -2px 25px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    z-index: 999;

    .page {
      width: 120px;
      height: 40px;
      background: #f9faff;
      border: 1px solid #3760f4;
      border-radius: 20px;
      box-sizing: border-box;
      color: #3760f4;
      font-size: 16px;
      text-align: center;
      line-height: 40px;
    }

    .submit {
      width: 120px;
      height: 40px;
      color: #ffffff;
      font-size: 16px;
      text-align: center;
      line-height: 40px;
      background-color: #3760F4;
      border-radius: 20px;
    }
  }

  .success {
    display: flex;
    align-items: center;
    flex-direction: column;

    div {
      width: 45%;
      margin-top: 100px;

      img {
        width: 100%;
      }
    }

    h1 {
      font-size: 22px;
      color: #000;
      margin: 20px 0;
    }

    p {
      font-size: 14px;
      color: #999999;
    }
  }
}
</style>
